import { Component, Input, OnInit, inject } from '@angular/core';
import { PatientAttachment } from 'app/core/models/patient-attachment.model';
import { ReferralSpecialty } from 'app/core/models/referral-specialty.model';
import { PatientAttachmentsService } from 'app/core/services/patient-attachments.service';
import { ProviderSpecialtyService } from 'app/core/services/provider-specialty.service';
import { debounce } from 'lodash-es';
import { ValidationHeaderComponent } from '../validation-header/validation-header.component';
import { NgClass } from '@angular/common';
import { NgSelectComponent } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { AdditionalDetailsInputComponent } from '../../../shared/components/additional-details-input/additional-details-input.component';

@Component({
    selector: 'app-consult-note-select-specialty',
    templateUrl: './consult-note-select-specialty.component.html',
    styleUrl: './consult-note-select-specialty.component.scss',
    imports: [ValidationHeaderComponent, NgSelectComponent, NgClass, FormsModule, AdditionalDetailsInputComponent]
})
export class ConsultNoteSelectSpecialtyComponent implements OnInit {
  private providerSpecialtyService = inject(ProviderSpecialtyService);
  private patientAttachmentsService = inject(PatientAttachmentsService);

  @Input() patientAttachment: PatientAttachment;
  collapsed = false;
  referralSpecialties: ReferralSpecialty[];

  ngOnInit(): void {
    this.providerSpecialtyService.getReferralSpecialties().subscribe(
      specialties => this.referralSpecialties = specialties
    )
  }

  debouncedSavePatientAttachment = debounce(() => this.savePatientAttachment(), 250, { maxWait: 1000 });

  onSelectedSpecialtyChange() {
    this.debouncedSavePatientAttachment()
  }

  onAdditionalDetailsChanged() {
    this.debouncedSavePatientAttachment();
  }

  onCollapseChange(collapse: boolean) {
    this.collapsed = collapse;
  }

  collapse() {
    this.collapsed = true;
  }

  expand() {
    this.collapsed = false;
  }

  private savePatientAttachment() {
    this.patientAttachmentsService.update(this.patientAttachment).subscribe((pa: PatientAttachment) => {
      const modifiedPatientAttachment: PatientAttachment = Object.assign({}, this.patientAttachment);
      modifiedPatientAttachment.selectedSpecialty = pa.selectedSpecialty;
      modifiedPatientAttachment.selectedSpecialtyAdditionalDetails = pa.selectedSpecialtyAdditionalDetails;
      modifiedPatientAttachment.selectedSpecialtyFrozen = pa.selectedSpecialtyFrozen;
      this.patientAttachmentsService.notifyPatientAttachmentChanged(modifiedPatientAttachment);
    })
  }
}
